import React from 'react';
import { Link } from 'react-router-dom';
import { StatCard } from './DashboardCard';

export type KpiStatVariant = 'primary' | 'secondary';

export interface KpiStatCardProps {
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  /** e.g. "Last 30 days", "Based on your pipeline" */
  hint?: string;
  link?: string;
  loading?: boolean;
  /** Retained for API compatibility; all stat tiles now render at one uniform size. */
  variant?: KpiStatVariant;
  iconTintClass?: string;
  /** Grid span / layout classes only. */
  className?: string;
}

/**
 * KPI stat tile. Now a thin wrapper over the shared StatCard/DashboardCard primitive so every
 * dashboard card shares one chrome. Props are unchanged so existing call sites need no edits.
 */
const KpiStatCard: React.FC<KpiStatCardProps> = ({
  title,
  value,
  icon,
  hint,
  link,
  loading,
  iconTintClass,
  className,
}) => {
  const card = (
    <StatCard
      label={title}
      value={loading ? '…' : value}
      caption={hint}
      icon={icon}
      iconTintClass={iconTintClass}
      className={link ? undefined : className}
    />
  );

  if (link) {
    return (
      <Link
        to={link}
        className={`block h-full rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-offset-gray-900 ${className ?? ''}`.trim()}
      >
        {card}
      </Link>
    );
  }
  return card;
};

export default KpiStatCard;
